import React, { useState } from 'react'

export default function TagCloud(props) {
  const [expanded, setExpanded] = useState(false)
  const top = props.tags.slice(0, expanded ? -1 : 10)

  return (
    <div className="tag-cloud">
      <div className="tag-cloud-heading">
        <h4>
          <i className="far fa-tags"></i>
          Filtros
        </h4>

        <div className="expander">
          {expanded && (
            <div onClick={() => setExpanded(false)}>
              <span>(mais usados)</span>
            </div>
          )}
        </div>
      </div>

      <ul>
        <li key="all" className="tag-item">
          <a href={`/${props.root}`} data-turbolinks="false">
            <span>Todos</span>
          </a>
        </li>
        {top.map((tag) => {
          return (
            <li key={tag.name} className="tag-item">
              <a href={`?search=${tag.name}`} data-turbolinks="false">
                <span>{tag.name}</span>
                <span className="count">({tag.count})</span>
              </a>
            </li>
          )
        })}
      </ul>

      {props.tags.length > 25 && !expanded && (
        <div className="expander" style={{ marginTop: '0.5em' }}>
          <div onClick={() => setExpanded(true)}>
            <span>(mostrar todos)</span>
          </div>
        </div>
      )}
    </div>
  )
}
